import { getCurrentTimestamps, getTimeStamps } from "../../../../lib/utils/dateAndTimeFormatting";

export const gameHeaders = [
  {
    title: "Teams",
  },
  {
    title: "Time",
  },
  {
    title: "Location",
  },
  {
    title: "",
    flex: 1.5,
  },
];

export const GAME_STATUS = {
  ENDED: "ended",
  POWER_UP: "powerUp",
  LIVE: "live",
  UPCOMING: "upcoming",
  POWERED_UP: "poweredUp",
};

/**
 * Formats a given date-time string into a more readable date and time format.
 * 
 * @param {string} dateTime - The date-time string to be formatted.
 * @returns {Object} - An object containing the formatted date and time.
 * @property {string} formattedDate - The formatted date in the format "Thu, 10 Oct".
 * @property {string} formattedTime - The formatted time in the format "4:30 pm".
 */

// This function checks whether the game is live upcoming or ready to deploy tokens
export const getGameStatus = (gameTime, matchEnd) => {
  const now = getCurrentTimestamps();
  const gameStart = getTimeStamps(gameTime);
  const gameEnd = getTimeStamps(matchEnd);
  const timeDifference = gameStart - now; // Difference in milliseconds
  const hoursBeforeDeployToken = process.env.REACT_APP_HOURS_BEFORE_DEPLOY_TOKEN || 24;
  const daysBeforeDeployToken = process.env.REACT_APP_DAYS_BEFORE_DEPLOY_TOKEN || 1;
  if (now > gameEnd) {
    // Game has ended
    return GAME_STATUS.ENDED;
  } else if(hoursBeforeDeployToken === "INFINITE" && now < gameStart) {
    // Game has not started
    return GAME_STATUS.POWER_UP;
  }  else if (timeDifference <= (daysBeforeDeployToken * hoursBeforeDeployToken * 60 * 60 * 1000) && timeDifference > 0) {
    // Less than or equal to given hours
    return GAME_STATUS.POWER_UP;
  } else if (timeDifference <= 0) {
    // Current time is at or after game start time
    return GAME_STATUS.LIVE;
  } else {
    // More than given hours
    return GAME_STATUS.UPCOMING;
  }
};

export const getCurrentGameStatus = (startTime, endTime, status) => {
  // status => status-to-powerup
  const _gameStatus = getGameStatus(startTime, endTime);

  switch(status) {
    case 1:
      return [{status: _gameStatus}];
    case 2:
      return [
        {status: GAME_STATUS.POWER_UP},
        {status: GAME_STATUS.UPCOMING}
      ];
    case 3:
      return [
        {status: GAME_STATUS.POWERED_UP},
        {status: _gameStatus}
      ]
    default:
      return [];
  }
}
